import { render, staticRenderFns } from "./SmallCard.vue?vue&type=template&id=8d55bb5e&"
import script from "./SmallCard.vue?vue&type=script&lang=js&"
export * from "./SmallCard.vue?vue&type=script&lang=js&"
import style0 from "./SmallCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports